import moment from 'moment';

export const HOO_TO_SCHEDULE_CONFIG = {
  dateRange: {
    label: 'Date Range Start and End',
    allowClear: true,
    type: 'daterange',
    defaultValue: [moment().format('YYYY-MM-DD')],
  },
};
